import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { apiConstant } from '../app.constant';
import { ActivateDeactivateUser, AgencyLogo, CurrencyFormat, DateFormat, OverTimeSetting, OverTimeSettings, ProfileImage, Settings, TimesheetDetails, TimesheetNotificationSettings, Client } from '../app.model';
import { TimesheetService } from './timesheet.service';
import * as moment from 'moment';
import { BehaviorSubject, Subject, Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class DataSharedService {
  agencyLogo!: string;
  profileImage: any = localStorage.getItem('profile_pic');
  permissionData: any = null;
  dateFormat: any = localStorage.getItem('dateFormat') ? localStorage.getItem('dateFormat') : '';
  candidateTrackingHrs: any = localStorage.getItem('candidateTrackingHrs') ? localStorage.getItem('candidateTrackingHrs') : 1;
  timesheetSubmissionEmails: any = localStorage.getItem('timesheetSubmissionEmails') ? localStorage.getItem('timesheetSubmissionEmails') : 0;
  timesheetApprovalEmails: any = localStorage.getItem('timesheetApprovalEmails') ? localStorage.getItem('timesheetApprovalEmails') : 0;
  allEmails: any = localStorage.getItem('allEmails') ? localStorage.getItem('allEmails') : 0;
  showAgencyLogoEmail: any = localStorage.getItem('showAgencyLogoEmail') ? localStorage.getItem('showAgencyLogoEmail') : 0;
  dateFormatList: any = [
    'MM-dd-YYYY',
    'dd-MM-YYYY',
    'MM-dd-YY',
    'dd-MM-YY',
    'yyyy-MM-dd',
    // 'yyyy-dd-MM',
    // 'dd-MM-yyyy',
    // 'MM-dd-yyyy',
    // 'yyyy/MM/dd',
    // 'yyyy/dd/MM',
    // 'dd/MM/yyyy',
    // 'MM/dd/yyyy',
    // 'dd MMM, yyyy',
    // 'MMM dd, yyyy',
  ];
  currencyFormatList: any = [
    '$',
    '£',
    '€',
  ];

  months: any = [
    { name: 'January', value: '01' },
    { name: 'February', value: '02' },
    { name: 'March', value: '03' },
    { name: 'April', value: '04' },
    { name: 'May', value: '05' },
    { name: 'June', value: '06' },
    { name: 'July', value: '07' },
    { name: 'August', value: '08' },
    { name: 'September', value: '09' },
    { name: 'October', value: '10' },
    { name: 'November', value: '11' },
    { name: 'December', value: '12' },
  ];

  years: number[] = [];

  private subject = new Subject<any>();

  constructor(
    private timesheetService: TimesheetService,
    private http: HttpClient,
    private datePipe: DatePipe
  ) {
    if (localStorage.getItem('user')) {
      this.setAgencyLogo()
      this.setProfileImage();
    }
  }

  getMonths() {
    return this.months;
  }

  getYears() {
    const now = moment();
    const currentYear = +now.format('YYYY');
    for (let y = currentYear; y >= currentYear - 5; y--) {
      this.years.push(y);
    }

    return this.years;
  }

  sendUpdate(message: string) {
    this.subject.next({ message: message });
  }

  getUpdate(): Observable<any> {
    return this.subject.asObservable();
  }

  getFormatedDate(date: string) {
    this.dateFormat = localStorage.getItem('dateFormat') ? localStorage.getItem('dateFormat') : '';
    try {
      return this.datePipe.transform(String(new Date(date)), (this.dateFormat ? this.dateFormat : 'YYYY-MM-dd'));
    } catch (e) {
      return date
    }
  }

  tranformDate(date: any) {
    return moment(date).format('YYYY-MM-DD')
  }

  transformTimeDate(date: any) {
    return moment(date).format('YYYY-MM-DD HH:mm:ss')
  }

  getFormatedDateUTC(date: string) {
    this.dateFormat = localStorage.getItem('dateFormat') ? localStorage.getItem('dateFormat') : '';
    try {
      return this.datePipe.transform(String(new Date(date).toLocaleString("en-US", { timeZone: "UTC" })), (this.dateFormat ? this.dateFormat : 'YYYY-MM-dd'));
    } catch (e) {
      return date
    }
  }

  setProfileImage() {
    this.profileImage = localStorage.getItem('profile_pic');
  }

  getImage(imageUrl: string) {
    return imageUrl
  }

  setAgencyLogo() {
    return new Promise(resolve => {
      this.getSettings().subscribe((res: any) => {
        const agencyLogo = res.data.find((x: any) => x.key === 'agency-logo');
        const dateFormat = res.data.find((x: any) => x.key === 'date-format');
        const candidateTrackingHrs = res.data.find((x: any) => x.key === 'track-hours');
        const timesheetSubmissionEmails = res.data.find((x: any) => x.key == 'timesheet-submission-emails');
        const timesheetApprovalEmails = res.data.find((x: any) => x.key == 'timesheet-approval-emails');
        const allEmails = res.data.find((x: any) => x.key == 'all-emails');
        const showAgencyLogoEmail = res.data.find((x: any) => x.key == 'show-agency-logo-email');

        if (dateFormat !== undefined && dateFormat !== "") {
          localStorage.setItem('dateFormat', dateFormat.value);
        }

        if (agencyLogo !== undefined && agencyLogo !== "") {
          this.agencyLogo = agencyLogo.value;
          resolve(this.agencyLogo);
        }

        if (candidateTrackingHrs !== undefined && candidateTrackingHrs !== "") {
          localStorage.setItem('candidateTrackingHrs', candidateTrackingHrs.value);
        }

        if (timesheetSubmissionEmails !== undefined && timesheetSubmissionEmails != "") {
          localStorage.setItem('timesheetSubmissionEmails', timesheetSubmissionEmails.value);
          this.timesheetSubmissionEmails = timesheetSubmissionEmails.value;
          resolve(this.timesheetSubmissionEmails);
        }

        if (timesheetApprovalEmails !== undefined && timesheetApprovalEmails != "") {
          localStorage.setItem('timesheetApprovalEmails', timesheetApprovalEmails.value);
          this.timesheetApprovalEmails = timesheetApprovalEmails.value
          resolve(this.timesheetApprovalEmails);
        }

        if (allEmails !== undefined && allEmails != "") {
          localStorage.setItem('allEmails', allEmails.value);
          this.allEmails = allEmails.value
          resolve(this.allEmails);
        }

        if (showAgencyLogoEmail !== undefined && showAgencyLogoEmail != "") {
          localStorage.setItem('showAgencyLogoEmail', showAgencyLogoEmail.value);
          this.showAgencyLogoEmail = showAgencyLogoEmail.value
          resolve(this.showAgencyLogoEmail);
        }
      });
    })
  }

  getSettings() {
    return this.http.get<Settings>(`${environment.baseUrl}` + apiConstant.SETTINGS);
  }

  uploadProfileImage(image: any) {
    return this.http.post<ProfileImage>(`${environment.baseUrl}` + apiConstant.SET_PROFILE_PIC, { profile_pic: image });
  }

  uploadAgencyLogo(image: any) {
    return this.http.post<AgencyLogo>(`${environment.baseUrl}` + apiConstant.SET_AGENCY_LOGO, { logo: image });
  }

  setDateFormat(format: any) {
    return this.http.post<DateFormat>(`${environment.baseUrl}` + apiConstant.SET_DATE_FORMAT, { date_format: format });
  }

  setCurrencyFormat(format: any) {
    return this.http.post<CurrencyFormat>(`${environment.baseUrl}` + apiConstant.SET_CURRENCY_FORMAT, { currency_format: format });
  }

  setTrackHrs(trackingHrs: any) {
    return this.http.post<DateFormat>(`${environment.baseUrl}` + `set-track-hours`, { set_track_hours: trackingHrs });
  }

  setAgencyLogoEmail(setAgencyEmailLogo: any) {
    return this.http.post<DateFormat>(`${environment.baseUrl}` + `set-email-template-settings`, { show_agency_logo_email: setAgencyEmailLogo });
  }

  setAgencyTimesheetNotifications(timesheetSubmissionEmails: boolean, timesheetApprovalEmails: boolean, allEmails: boolean) {
    return this.http.post<DateFormat>(`${environment.baseUrl}` + `agency-timesheet-notifications`, { timesheet_submission_emails: timesheetSubmissionEmails, timesheet_approval_emails: timesheetApprovalEmails, all_emails: allEmails });
  }
  getTimesheetNotificationSettings() {
    return this.http.get<TimesheetNotificationSettings>(`${environment.baseUrl}` + `timesheet-notification-settings`);
  }
  updateTimesheetNotificationSettings(data: any) {
    return this.http.patch<TimesheetNotificationSettings>(`${environment.baseUrl}` + `timesheet-notification-settings`, { email_type: data.email_type, frequency: data.frequency, day: data.day, time: data.time });
  }

  getOverTimeSettings() {
    return this.http.get<OverTimeSettings>(`${environment.baseUrl}` + apiConstant.OVERTIME_SETTINGS);
  }

  updateOverTimeSettings(overTimeSettings: any) {
    return this.http.post<ActivateDeactivateUser>(`${environment.baseUrl}` + apiConstant.OVERTIME_SETTINGS, { overtime_settings: overTimeSettings });
  }

  setAgencyAddress(payload: any) {
    return this.http.post<Client>(`${environment.baseUrl}` + apiConstant.UPDATE_AGENCY_ADDRESS, { address: payload });
  }

  getAgencyAddress() {
    return this.http.get<OverTimeSettings>(`${environment.baseUrl}` + apiConstant.GET_AGENCY_ADDRESS);
  }

  setAgencyBankDetails(payload: any) {
    return this.http.post<Client>(`${environment.baseUrl}` + apiConstant.UPDATE_AGENCY_BANK, { bank_details: payload });
  }

  getAgencyBankDetails() {
    return this.http.get<OverTimeSettings>(`${environment.baseUrl}` + apiConstant.GET_AGENCY_BANK);
  }

  getCompanyDetails() {
    return this.http.get<OverTimeSettings>(`${environment.baseUrl}` + apiConstant.GET_COMPANY_DETAILS);
  }

  setCompanyDetails(payload: any) {
    return this.http.post<Client>(`${environment.baseUrl}` + apiConstant.UPDATE_COMPANY_DETAILS, { agency_details: payload });
  }

  importPreview(importEndpoint: string, formData: any) {
    return this.http.post<any>(`${environment.baseUrl}` + importEndpoint, formData);
  }

  importStart(importEndpoint: string, formData: any) {
    return this.http.post<any>(`${environment.baseUrl}` + importEndpoint, formData);
  }

  getImportFields(endpoint: string) {
    return this.http.get<{ data: any[] }>(`${environment.baseUrl}` + endpoint);
  }

}